import React from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './button-group.scss';
export const ButtonGroup = ({
  onClose
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.buttonsContainer
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Cancel",
    type: "defaultGrey",
    onClick: onClose,
    dataButton: "Cancel",
    className: classes.button
  }, "Back To Product"));
};